import React, { Component } from "react";
import TransferInterbancaService from "../../../services/transferencias/TransferInterbancaService";
import Popup from "react-popup";

import $ from "jquery";
import CuentaExternaService from "../../../services/transferencias/CuentaExternaService";
import TransferCuentasTercerosService from "../../../services/transferencias/TransferCuentasTercerosService";
import { trackPromise } from "react-promise-tracker";
import { formatoSeparadorMilesValue } from "../../generico/utils/FormatoInput";
import authService from "../../../services/login/auth.service";
import ReimpresionCuentaTerceroService from "../../../services/consultas/ReimpresionCuentaTerceroService";
import ReimpresionXpressService from "../../../services/consultas/ReimpresionXpressService";
import ReimpresionInterbancariaService from "../../../services/consultas/ReimpresionInterbancariaService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf, faClose } from "@fortawesome/free-solid-svg-icons";
import { separadorPuntoMiles } from "../../generico/utils/FormatoInput";
export default class PopupTransferenciaCuentaTerceroDetalle extends Component {

  constructor(props) {
    super(props);
    this.state = {
      jsonData: {}
    };

    this.initData();
  }

  componentDidMount() {

  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  initData() {
    this.state = this.getInitialState();



  }

  getInitialState = () => {

    $("#inputNroCuenta").val("");

    return {
      entidadNew: "",
      nroCuentaNew: "",
      nombreApellidoNew: "",
      tipoDocNew: "",
      documentoNew: "",
      btnGuardarEnabled: false,


    }
    console.log(this.props.items)

  };





  descargar() {

    //Interbancarias cuentas a terceros
    this.descargarTransfInterb(this.props.items)



    // return (<PopupMostrarDetalle addCuentaCallback={this.addCuentaCallback.bind(this)} />);
  }
  descargarTransfXpress = async (row) => {

    var data = JSON.stringify({
      titulo: "Interbancarias 24 / 7",
      nroOperacion: row.comprobante,
      cuentaTitular: row.cuentaOrigen + " - " + row.nombreOrigen,
      tipo: row.tipo,
      moneda: row.moneda,
      cuentaCredito: row.cuentaDestino,
      importeDebito: formatoSeparadorMilesValue(row.importeDebito),
      importeCredito: formatoSeparadorMilesValue(row.importeCredito),
      titularCuentaDestino: row.nombreDestino,
      entidad: row.entidad,
      motivo: row.motivo,//
      celularDestinatario: row.cedulaDestino,//
      fechaOperacion: row.fechaTrans
    });

    await trackPromise(
      ReimpresionXpressService.descargarComponente(data)
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");
        })
        .catch(function (error) {
          console.log(error);
        })
    );

  }
  descargarTransfInterb = async (row) => {

    var data = JSON.stringify({
      titulo: "Transferencia a Cuentas de Terceros",
      nroOperacion: row.operacion,
      cuentaTitular: row.cuentaOrigen + " - " + row.nombreOrigen,
      tipo: row.tipo,
      moneda: row.moneda,
      cuentaCredito: row.cuentaDestino,
      importeDebito: separadorPuntoMiles(row.importeDebito),
      importeCredito: separadorPuntoMiles(row.importeCredito),
      titularCuentaDestino: row.nombreDestino,
      fechaOperacion: row.fechaTrans
    });

    await trackPromise(
      ReimpresionCuentaTerceroService.descargarComprobante(data)
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");
        })
        .catch(function (error) {
          console.log(error);
        })
    );

  }
  descargarTransfSipap = async (row) => {
    await trackPromise(
      ReimpresionInterbancariaService.descagarComponente(
        "Interbancarias via SIPAP",
        row.operacion,
        row.cuentaOrigen +
        " - " +
        row.nombreOrigen,
        row.tipo,
        row.moneda,
        row.cuentaOrigen,
        row.cuentaDestino,
        formatoSeparadorMilesValue(  row.importeDebito),
          formatoSeparadorMilesValue(row.importeCredito),
        row.nombreDestino,
        row.entidad,
        row.fechaTrans,
        row.tipoDocumentoDestino,//
        row.nroDocDestino//
      )
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");
        })
        .catch(function (error) {
          console.log(error);
        })
    );

  }


  render() {


    return (
      <form
        id="idFormAddCuenta"
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <div
          className="modal fade"
          id="modal-transf-tercero"
          data-backdrop="false"
        >

          <div className="modal-dialog  modal-dialog-centered  modal-dialog-centered">
            <div className="modal-content modal-content-dt">
              <div title="Close" class="pull-right" style={{ "text-align": "right" }} onClick={() => {
                $("#idFormAddCuenta").validate().resetForm();
                this.setState(this.getInitialState());
              }}><i class="fa fa-times pull-right" data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  $("#idFormAddCuenta").validate().resetForm();
                  this.setState(this.getInitialState());
                }}></i>
              </div>
              <div className="modal-header modal-header-dtt" style={{ "padding-top": " 0px" }}>

                <h4 className="modal-title" style={{ color: "#4e4e4e" }}>Transferencia a Cuentas de Terceros</h4>
                <div>
                  
                </div>
              </div>


              <div className="modal-body">
                <div className="row form-detales-trans">
                  <div className="col-12">
                    <div className="modal-header  modal-header-dt" style={{ padding: "0% 0 1% 0" }} >
                      <h5 className="modal-title modal-title-dt" >Detalles</h5>
                    </div>
                    <div class="d-flex flex-row">
                      <div class="p-1 col-5">Comprobante</div>
                      <div class="p-1" >{this.props.items.comprobante}</div>

                    </div>
                    <div class="d-flex flex-row">
                      <div class="p-1 col-5">Fecha de operación</div>
                      <div class="p-1" >{this.props.items.fechaTrans}</div>

                    </div>
                    <div class="d-flex flex-row">
                      <div class="p-1 col-5">Monto</div>
                      <div class="p-1" >{formatoSeparadorMilesValue(this.props.items.importeCredito)}</div>

                    </div>
                    <div class="d-flex flex-row">
                      <div class="p-1 col-5">Concepto</div>
                      <div class="p-1" >{this.props.items.concepto}</div>

                    </div>
                    <div class="d-flex flex-row">
                      <div class="p-1 col-5">Documento</div>
                      <div class="p-1" >{this.props.items.nroDocOrigen}</div>

                    </div>
                    <div className="modal-header modal-header-dt" style={{ color: "#4c4c4c", padding: "4% 0 1% 0" }} >
                      <h5 className="modal-title modal-title-dt">  Destino</h5>
                    </div>
                    <div class="d-flex flex-row">
                      <div class="p-1 col-5">Nombre</div>
                      <div class="p-1">{this.props.items.nombreDestino}</div>

                    </div>
                    <div class="d-flex flex-row">
                      <div class="p-1 col-5">Cuenta</div>
                      <div class="p-1">{this.props.items.cuentaDestino}</div>

                    </div>
                    
                    <div className="modal-header modal-header-dt" style={{ color: "#4c4c4c", padding: "4% 0 1% 0" }} >
                      <h5 className="modal-title modal-title-dt"> Origen</h5>
                    </div>
                    <div class="d-flex flex-row">
                      <div class="p-1 col-5">Nombre</div>
                      <div class="p-1">{this.props.items.nombreOrigen}</div>

                    </div>
                    <div class="d-flex flex-row">
                      <div class="p-1 col-5">Cuenta</div>
                      <div class="p-1">{this.props.items.cuentaOrigen}</div>

                    </div>
                    

                  </div>

                </div>
              </div>
              <div>
                <div className="row">
                <div className="col-md-6">
                  <button
                    type="button"
                    className="btn btn-cu-quintary btn-consulta"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      $("#idFormAddCuenta").validate().resetForm();
                      this.setState(this.getInitialState());
                    }}
                  >
                   <FontAwesomeIcon icon={faClose} />  Cerrar
                  </button>
                </div>
                
                <div className="col-md-6">
                {this.props.items.tipoMovimiento==='D' &&
                  <button
                    type="button"
                    className="btn btn-cu-primary"

                    onClick={() => {
                      this.descargar();
                    }}
                  >
                     <FontAwesomeIcon icon={faFilePdf} /> Descargar
                  </button>
                }</div>
                </div>
              </div>
            </div>
            {/* /.modal-content */}
          </div>
          {/* /.modal-dialog */}
          <a
            data-controls-modal="modal-cuenta"
            ref={(a) => (this.modalCuenta = a)}
            data-backdrop="false"
            href="#"
            hidden
            id="showModalCuenta"
            data-toggle="modal"
            data-target={"#modal-cuenta"}
          ></a>
        </div>
      </form>
    );
  }
}
